import { createContext, useContext } from 'react';

interface TabContainerContextValue {
  isInTabContainer: boolean;
  tabBarHeight: number;
  isBarVisible: boolean;
}

export const TabContainerContext = createContext<TabContainerContextValue | null>(
  null
);

/**
 * Hook to easily access the TabContainer context.
 */
export const useTabContainer = () => {
  return useContext(TabContainerContext);
};